"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useScript(url, id) {
    if (id === void 0) { id = null; }
    react_1.useEffect(function () {
        var script = document.createElement('script');
        script.src = url;
        script.async = true;
        var element = id ? document.getElementById(id) : document.head;
        element.appendChild(script);
        return function () {
            element.removeChild(script);
        };
    }, [url]);
}
exports.default = useScript;
